export default __webpack_public_path__ + "static/media/appstore.3619fe31.png";